const { default: Axios } = require("axios");
const { default: api } = require("../../api");

const service = {
  async getData() {
    return new Promise((resolve, reject) => {
      Axios.get(api.base+api.province)
        .then((res) => {
          if(res.data && res.data.results){
            resolve(res.data.results)
          } else if (res.data) {
            resolve(res.data)
          } else {
            resolve(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default service;
